import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-precificacao-list',
  templateUrl: './precificacao-list.component.html',
  styleUrls: ['./precificacao-list.component.scss']
})
export class PrecificacaoListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
